module.exports = __webpack_public_path__ + "static/CleanAir-Desktop-Header-1920x340-Curve-Disclaimer-2x-d11a6700eaa51aad607927847804a0a6.png";